<ng-container *ngIf="getPromotion(); let promo">
  <div class="d-flex justify-content-start align-items-center h-100 p-l-sm p-r-sm">
    <div *ngIf="promotionTagIconTemplate" [outerHTML]="promotionTagIconTemplate"></div>
    <span class="font-weight-bold p-l-xs">{{ promo | truncate: [promotionTextMaxLength] }}</span>
  </div>
</ng-container>
